import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { Divider } from 'Src/feature/divider/Divider';
import { FormField } from 'Src/feature/form/FormField';

import styles from './CheckItemDetailNote.module.scss';

const sectionId = 'CheckItemDetailNote';

interface CheckItemDetailNoteProps {
  onChange: (next: string) => void;
  disabled: boolean;
  value: string;
  ['data-card-id']: string;
  inputRef?: ((ref: HTMLInputElement | HTMLTextAreaElement) => void);
}

const CheckItemDetailNote: FC<CheckItemDetailNoteProps> = (props) => {
  const { t } = useTranslation();
  const { value, disabled, onChange, inputRef } = props;
  
  return (
    <Flex
      data-testid={sectionId}
      gap="sm"
      className={styles.root}
      data-card-id={props['data-card-id']}
    >
      <Divider variant="stubby" />
      <div className={styles.headingRoot}>
        <Copy className={styles.headingText} value={t('labels.note')} color="textPrimary" />
        <Copy className={styles.headingText} value={t('labels.util.wrappedWithParenthesis', { value: t('labels.optional_lowerCase') })} color="textSecondary" />
      </div>
      <FormField
        type="text"
        variant="underline"
        multiline
        placeholder={t('notes.placeholder')}
        value={value}
        disabled={disabled}
        inputRef={inputRef}
        onChange={(event) => {
          onChange(event.target.value);
        }}
        classes={{ input: styles.input }}
      />
    </Flex>
  );
};

export { CheckItemDetailNote, sectionId };
